import { Component } from '@angular/core';

@Component({
  selector: 'app-issue-contract-report',
  templateUrl: './issue-contract-report.component.html',
  styleUrl: './issue-contract-report.component.scss'
})
export class IssueContractReportComponent {

}
